window.JBProductGalleryMotion = {
  capture(gallery, frames) {
    const origin = gallery.getBoundingClientRect();
    const cover = document.createElement('div');
    cover.className = 'jb-product-photo-snapshot';
    cover.setAttribute('aria-hidden', 'true'); cover.inert = true;
    Object.assign(cover.style, { position: 'absolute', inset: '0', zIndex: '7', pointerEvents: 'none', overflow: 'hidden', contain: 'paint' });
    for (const frame of frames) {
      const source = frame.querySelector('img');
      if (!source || frame.hidden || !source.complete || !source.naturalWidth) continue;
      const box = source.getBoundingClientRect();
      if (!box.width || !box.height) continue;
      const computed = getComputedStyle(source);
      const image = document.createElement('img');
      image.src = source.currentSrc || source.src; image.alt = ''; image.width = source.naturalWidth; image.height = source.naturalHeight;
      Object.assign(image.style, {
        display: 'block', position: 'absolute', left: (box.left - origin.left - gallery.clientLeft) + 'px', top: (box.top - origin.top - gallery.clientTop) + 'px',
        width: box.width + 'px', height: box.height + 'px', maxWidth: 'none', maxHeight: 'none', boxSizing: 'border-box', margin: '0',
        padding: computed.padding, border: computed.border, borderRadius: computed.borderRadius,
        objectFit: computed.objectFit, objectPosition: computed.objectPosition, background: computed.backgroundColor,
        opacity: computed.opacity, filter: computed.filter, transform: 'none', transition: 'none'
      });
      cover.append(image);
    }
    gallery.append(cover); return cover;
  }
};

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = [];
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider ? this.productSlider.dataset.hideVariants === 'true' : false;
      }

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      this.other = Array.from(document.querySelectorAll('variant-selects, variant-radios')).filter(selector =>
        selector !== this && selector.dataset.section === this.dataset.section && selector.dataset.url === this.dataset.url);
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.prefetchProductUrls();
    }

    disconnectedCallback() {
      this._variantRequest = (this._variantRequest || 0) + 1;
      this._variantController?.abort();
    }

    onVariantChange(event) {
      if (event && !event.target.closest?.('fieldset[data-index]')) return;
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantText();

      this.renderVariantInfo();

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        variantTitle: this.options.join(' / '),
        sectionId: this.dataset.section
      });
    }

    getFieldsets() {
      return Array.from(this.querySelectorAll('fieldset[data-index]')).sort((a, b) => Number(a.dataset.index.replace('option', '')) - Number(b.dataset.index.replace('option', '')));
    }

    updateOptions() {
      this.fieldsets = this.getFieldsets();
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked')?.value || '');
        }
      });
    }
    updateVariantText() {
      const fieldsets = this.getFieldsets();
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.textContent = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      this.other = Array.from(document.querySelectorAll('variant-selects, variant-radios')).filter(selector =>
        selector !== this && selector.dataset.section === this.dataset.section && selector.dataset.url === this.dataset.url);
      this.other.forEach(other => {
        let fieldsets_array = other.getFieldsets();
        this.options.forEach((option, i) => {
          if (!fieldsets_array[i]) return;
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            const input = Array.from(fieldsets_array[i].querySelectorAll('input')).find(input => input.value === option);
            if (input) input.checked = true;
          }
        });
        other.updateOptions();
        other.currentVariant = this.currentVariant;
        other.updateVariantText();
        other.setDisabled();
      });
    }

    async updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      let cover = null;
      const gallery = this.productSlider.closest('.jb-product-experience .product-image-container');
      if (gallery && activeMedia && this.productSlider.querySelector('.product-images__slide') !== activeMedia) {
        const revision = this._variantRequest;
        const source = activeMedia.querySelector('img');
        if (source) {
          const candidates = (source.getAttribute('data-srcset') || source.getAttribute('srcset') || '').split(',').map(value => value.trim().split(/\s+/)[0]).filter(Boolean);
          const url = candidates.at(-1) || source.getAttribute('data-src') || source.currentSrc || source.src;
          const image = new Image(); image.decoding = 'async'; image.src = url;
          try { await image.decode(); } catch { return; }
          if (!this.isConnected || revision !== this._variantRequest) return;
          source.removeAttribute('srcset'); source.removeAttribute('data-srcset'); source.removeAttribute('data-src'); source.src = url;
          source.classList.remove('lazyload', 'lazyloading'); source.classList.add('lazyloaded', 'no-blur');
        }
        this._photoAnimation?.cancel(); this._photoCover?.remove();
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) cover = window.JBProductGalleryMotion.capture(gallery, [...this.productSlider.querySelectorAll('.product-images__slide')]);
      }

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

      if (cover) {
        this._photoCover = cover;
        this._photoAnimation = cover.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
        this._photoAnimation.finished.catch(() => {}).then(() => cover.remove());
      }

    }
    setActiveMedia(activeMedia) {
			if (!activeMedia) return;

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      if (!productSlider) return;

      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (!activeMedia) return;

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);
          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const url = new URL(this.dataset.url, location.origin);
      for (const [key, value] of new URLSearchParams(location.search)) {
        if (key !== 'variant' && key !== 'option_values' && key !== 'section_id') url.searchParams.append(key, value);
      }
      url.searchParams.set('variant', this.currentVariant.id);
      url.searchParams.set('view', 'jb');
      url.hash = location.hash;
      if (window.JBProductLinks) url.href = new URL(window.JBProductLinks.url(url.href) || url.href, location.origin).href;
      window.history.replaceState(window.history.state, '', url);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.productWrapper?.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      pickUpAvailability.update(this.currentVariant);
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    prefetchProductUrls() {
      if (!this.prefetchCache) {
        this.prefetchCache = new Map();
      }
      var self = this;
      var sectionId = this.dataset.section;
      var currentUrl = this.dataset.url;

      this.querySelectorAll('[data-product-url]').forEach(function(el) {
        var productUrl = el.dataset.productUrl;
        if (!productUrl || productUrl === currentUrl) return;

        var target = el.closest('fieldset');
        if (!target) return;

        // For selects, attach to the select element; for radios, attach to the label
        var hoverTarget = el.tagName === 'OPTION' ? el.closest('select') : el.nextElementSibling;
        if (!hoverTarget) hoverTarget = target;

        if (hoverTarget.dataset.jbProductPrefetch) return;
        hoverTarget.dataset.jbProductPrefetch = 'true';
        hoverTarget.addEventListener('mouseenter', function() {
          if (self.prefetchCache.has(productUrl)) return;
          self.fetchSection(productUrl + '?view=' + (sectionId.includes('quick-view') ? 'quick-view' : 'jb') + '&section_id=' + sectionId)
            .then(function(text) {
              self.prefetchCache.set(productUrl, text);
            })
            .catch(function() {});
        }, { once: true });
      });
    }

    async fetchSection(url, options = {}) {
      const controller = new AbortController();
      const abort = () => controller.abort();
      if (options.signal?.aborted) abort();
      else options.signal?.addEventListener('abort', abort, { once: true });
      const timeout = setTimeout(abort, 20000);
      try {
        const response = await fetch(url, { ...options, signal: controller.signal });
        if (!response.ok) throw new Error('Product unavailable');
        return await response.text();
      } finally { clearTimeout(timeout); options.signal?.removeEventListener('abort', abort); }
    }

    getProductUrl() {
      var currentUrl = this.dataset.url;
      for (var i = 0; i < this.fieldsets.length; i++) {
        var fieldset = this.fieldsets[i];
        var productUrl = null;
        var select = fieldset.querySelector('select');
        if (select) {
          var selected = select.selectedOptions[0];
          if (selected) {
            productUrl = selected.dataset.productUrl;
          }
        } else {
          var checked = fieldset.querySelector('input:checked');
          if (checked) {
            productUrl = checked.dataset.productUrl;
          }
        }
        if (productUrl && productUrl !== currentUrl) {
          return productUrl;
        }
      }
      return null;
    }

    switchProduct(productUrl) {
      var sectionId = this.dataset.section;
      var self = this;
      const requestNumber = this._variantRequest = (this._variantRequest || 0) + 1;
      this._variantController?.abort();
      const controller = this._variantController = new AbortController();
      const originalSection = this.closest('[id="shopify-section-' + sectionId + '"]');

      var handleResponse = function(responseText) {
        if (requestNumber !== self._variantRequest || controller.signal.aborted || !self.isConnected) return;
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var newSection = html.getElementById('shopify-section-' + sectionId);
        var currentSection = document.getElementById('shopify-section-' + sectionId);

        if (newSection && currentSection && currentSection === originalSection) {
          const targetUrl = new URL(productUrl, location.origin);
          for (const [key, value] of new URLSearchParams(location.search)) {
            if (key !== 'variant' && key !== 'option_values' && key !== 'section_id') targetUrl.searchParams.append(key, value);
          }
          targetUrl.searchParams.set('view', 'jb');
          targetUrl.hash = location.hash;
          if (window.JBProductLinks) targetUrl.href = new URL(window.JBProductLinks.url(targetUrl.href) || targetUrl.href, location.origin).href;
          currentSection.querySelectorAll('.jb-product-experience').forEach(root => root.dispatchEvent(new Event('jb:experience-dispose')));
          currentSection.innerHTML = newSection.innerHTML;
          if (self.updateUrl) window.history.replaceState(window.history.state, '', targetUrl);
          document.dispatchEvent(new Event('jb:product-replaced'));
        } else throw new Error('Product section unavailable');
      };

      const url = new URL(productUrl, location.origin);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('view', sectionId.includes('quick-view') ? 'quick-view' : 'jb');
      const response = this.prefetchCache?.has(productUrl)
        ? Promise.resolve(this.prefetchCache.get(productUrl))
        : this.fetchSection(url, { signal: controller.signal });
      return response.then(handleResponse).catch(() => {
        if (requestNumber !== this._variantRequest || controller.signal.aborted || !this.isConnected) return;
        originalSection?.querySelector('product-form')?.handleErrorMessage('Unable to load this creation. Please select your option again.');
      });
    }

    renderVariantInfo() {
      const requestNumber = this._variantRequest = (this._variantRequest || 0) + 1;
      this._variantController?.abort();
      const controller = this._variantController = new AbortController();
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      // Combined listings: check if selected option points to a different product
      const productUrl = this.getProductUrl();
      if (productUrl) {
        this.switchProduct(productUrl);
        return;
      }

      const scrollY = window.scrollY;

      this.fetchSection(`${this.dataset.url}?view=${this.dataset.section.includes('quick-view') ? 'quick-view' : 'jb'}&option_values=${ids.join(',')}&section_id=${this.dataset.section}`, { signal: controller.signal })
        .then((responseText) => {
          if (requestNumber !== this._variantRequest || controller.signal.aborted || !this.isConnected) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };
          } else {
            this.currentVariant = null;
          }
          const currentSpan = document.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && currentSpan) currentSpan.replaceWith(span.cloneNode(true));

          // Combined listings server-side fallback: check if response is for a different product
          if (span && span.dataset.productUrl && span.dataset.productUrl !== this.dataset.url) {
            this.switchProduct(span.dataset.productUrl);
            return;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          // 4. Apply updated state
          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          // Quick shop requests only the current photograph, not the full gallery.
          if (!this.updateUrl && this.productSlider && this.currentVariant.featured_media) {
            const mediaId = `Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
            const updatedMedia = html.getElementById(mediaId);
            if (updatedMedia) this.productSlider.replaceChildren(updatedMedia.cloneNode(true));
          }
          this.updateMedia();
          this.updatePickupAvailability();
          this.updateOther?.();
          dispatchCustomEvent('product:variant-change', {
            variant: this.currentVariant, variantTitle: this.options?.join(' / ') || '', sectionId: this.dataset.section
          });
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        })
        .catch((error) => {
          if (requestNumber !== this._variantRequest || controller.signal.aborted || !this.isConnected) return;
          const form = document.getElementById(`product-form-${this.dataset.section}`)?.closest('product-form');
          form?.handleErrorMessage('Unable to update product options. Please select your option again.');
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = productForm.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.getElementById(`product-form-${this.dataset.section}`)?.querySelectorAll('.single-add-to-cart-button') || [];
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.value === '' || opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]')?.dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      let setValue = this.getImageSetName(this.options[optionPosition] || '');
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value || '';
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      if (this._galleryAbort) return;
      this._galleryAbort = new AbortController();
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      this.galleryObserver = new MutationObserver(() => {
        this.setupProductGallery();
        if (this.pagination) this.onPaginationResize();
      });

      this.galleryObserver.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this), { signal: this._galleryAbort.signal, passive: true });
      }
    }
    disconnectedCallback() {
      this._pendingZoom = null;
      this.pswp?.close();
      this.pswp?.destroy();
      this._lightboxAbort?.abort();
      this._zoomBindings?.abort();
      this.galleryObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this._galleryAbort?.abort();
      this._galleryAbort = null;
      this._variantGalleryBound = false;
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();

      if (this._variantGalleryBound) return;
      this._variantGalleryBound = true;
      document.addEventListener('product:variant-change', (e) => {
        const sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
        if (e.detail?.sectionId && sectionId && e.detail.sectionId !== sectionId) return;
        if (e.detail && e.detail.variantTitle && e.detail.variantTitle !== 'Default Title') {
          this.dataset.variantTitle = e.detail.variantTitle;
          this.updatePswpProductInfo();
        }
      }, { signal: this._galleryAbort.signal });
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.dataset.jbZoomSrc || activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          thumbSrc: activelink.dataset.thumbSrc || activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    buildPswpThumbnails(items) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      container.innerHTML = '';
      if (this.dataset.lightboxThumbnails === 'false' || items.length <= 1) {
        container.parentElement.style.display = 'none';
        return;
      }
      container.parentElement.style.display = '';
      items.forEach((item, index) => {
        const thumb = document.createElement('div');
        thumb.className = 'pswp__thumb';
        thumb.dataset.index = index;
        const img = document.createElement('img');
        img.src = item.thumbSrc;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        container.appendChild(thumb);
      });
    }
    updatePswpProductInfo() {
      const infoEl = this.pswpElement.querySelector('.pswp__product-info');
      if (!infoEl) return;
      if (this.dataset.lightboxProductInfo === 'false') {
        infoEl.style.display = 'none';
        return;
      }
      infoEl.style.display = '';
      const titleEl = infoEl.querySelector('.pswp__product-title');
      const variantEl = infoEl.querySelector('.pswp__variant-title');
      if (titleEl) titleEl.textContent = this.dataset.productTitle || '';
      if (variantEl) variantEl.textContent = this.dataset.variantTitle || '';
    }
    syncPswpThumbnails(index) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      const thumbs = container.querySelectorAll('.pswp__thumb');
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
      });
      const activeThumb = container.querySelector('.pswp__thumb.is-active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      }
    }
    setEventListeners() {
      this._zoomBindings?.abort();
      this._zoomBindings = new AbortController();
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0);
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: true,
        allowPanToNext: true,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true
      };

      const _this = this;

      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        link.addEventListener('click', (e) => _this.zoomClick(e, link), { signal: _this._zoomBindings.signal });
      });

      this.video_containers.forEach((container) => {
        const closeButton = container.querySelector('button');
        if (!closeButton) return;
        closeButton.addEventListener('click', function () {
          container.setAttribute('hidden', '');
        }, { signal: this._zoomBindings.signal });
      });
    }
    zoomClick(e, link) {
      if (window.JBPressZoom && link.hasAttribute('data-jb-press-zoom')) { e.preventDefault(); return; }
      if (typeof PhotoSwipe === 'undefined' || !this.pswpElement) return;
      e.preventDefault();
      if (this.pswp) {
        if (this._lightboxClosing) this._pendingZoom = link;
        return;
      }
      if (this.pswpElement._jbLightbox) return;
      this._lightboxAbort?.abort();
      this._lightboxAbort = new AbortController();
      const lightboxSignal = this._lightboxAbort.signal;
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0 && element.querySelector('.product-single__media-zoom'));
      let items = this.buildItems(this.activeImages);
      let parent = link.closest('.product-images__slide');
      let i = this.activeImages.indexOf(parent);
      if (!items.length || i < 0) return;
      this.pswpOptions.index = parseInt(i, 10);
      this.pswpOptions.getThumbBoundsFn = () => {
        const thumbnail = link.closest('.product-single__media'),
          pageYScroll = window.scrollY || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      };
      if (typeof PhotoSwipe !== 'undefined') {
        this.buildPswpThumbnails(items);
        this.updatePswpProductInfo();

        const bottomBar = this.pswpElement.querySelector('.pswp__bottom-bar');
        if (bottomBar) {
          ['mousedown', 'touchstart', 'pointerdown'].forEach(evtName => {
            bottomBar.addEventListener(evtName, (evt) => evt.stopPropagation(), { signal: lightboxSignal });
          });
        }

        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, items, this.pswpOptions);
        this.pswp = pswp;
        this.pswpElement._jbLightbox = pswp;
        this._lightboxClosing = false;
        const _this = this;

        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 140
            };
          });
        });

        const scrollWrap = this.pswpElement.querySelector('.pswp__scroll-wrap');
        const resetScroll = function() {
          if (scrollWrap) scrollWrap.scrollLeft = 0;
          _this.pswpElement.scrollLeft = 0;
        };

        pswp.listen('beforeChange', function () {
          const index = pswp.getCurrentIndex();
          _this.syncPswpThumbnails(index);
          resetScroll();
        });

        const thumbsInner = this.pswpElement.querySelector('.pswp__thumbs-inner');
        if (thumbsInner) {
          thumbsInner.addEventListener('click', function handler(evt) {
            evt.stopPropagation();
            const thumb = evt.target.closest('.pswp__thumb');
            if (thumb) {
              pswp.goTo(parseInt(thumb.dataset.index, 10));
              resetScroll();
            }
          }, { signal: lightboxSignal });
        }

        pswp.listen('close', function () {
          _this._lightboxClosing = true;
          _this._lightboxAbort?.abort();
          const container = _this.pswpElement.querySelector('.pswp__thumbs-inner');
          if (container) container.innerHTML = '';
        });

        pswp.listen('destroy', function () {
          _this._lightboxAbort?.abort();
          if (_this.pswpElement._jbLightbox === pswp) delete _this.pswpElement._jbLightbox;
          if (_this.pswp === pswp) _this.pswp = null;
          _this._lightboxClosing = false;
          const pending = _this._pendingZoom;
          _this._pendingZoom = null;
          if (pending?.isConnected && _this.isConnected) queueMicrotask(() => _this.zoomClick({ preventDefault() {} }, pending));
        });
        try { pswp.init(); } catch (failure) {
          this._lightboxAbort.abort();
          this.pswp = null;
          delete this.pswpElement._jbLightbox;
          pswp.destroy();
          return;
        }
        this.syncPswpThumbnails(this.pswpOptions.index);
      }
      e.preventDefault();
    }
    setupPagination() {
      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');
      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');
      this.prevButton?.addEventListener('click', this.onPaginationButtonClick.bind(this), { signal: this._galleryAbort.signal });
      this.nextButton?.addEventListener('click', this.onPaginationButtonClick.bind(this), { signal: this._galleryAbort.signal });
      this.onPaginationResize();
    }
    onPaginationResize() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) {
        if (this.prevButton) this.prevButton.disabled = true;
        if (this.nextButton) this.nextButton.disabled = true;
        if (this.currentPageElement) this.currentPageElement.textContent = this.sliderItemsToShow.length ? '1' : '0';
        if (this.pageTotalElement) this.pageTotalElement.textContent = this.sliderItemsToShow.length;
        return;
      }

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton || !this.prevButton) return;
      if (!this.sliderItemOffset || !this.sliderItemsToShow.length) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.max(1, Math.min(this.sliderItemsToShow.length, Math.round(this.scrollLeft / this.sliderItemOffset) + 1));

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.formController) return;
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;
      const variantInput = this.form.querySelector('[name=id]');
      if (!variantInput) return;
      this.formController = new AbortController();
      variantInput.disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this), { signal: this.formController.signal });
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    disconnectedCallback() { this.formController?.abort(); this.formController = null; }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitting) return;
      if (this.form.querySelector('.single-add-to-cart-button:disabled, .single-add-to-cart-button[aria-disabled="true"]')) return;
      if (this.closest('.product-information--inner')?.querySelector('.cus_rq_hd_show_btn')) return;
      if (!this.form.reportValidity()) {
        return;
      }
      this.submitting = true;
      const submitButtons = this.form.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname + window.location.search);
      config.body = formData;

      const submit = () => window.JBCart.add(`${theme.routes.cart_add_url.replace(/\.js$/, '')}.js`, config, { productId: this.dataset.jbProductId, limited: this.dataset.jbSinglePiece === 'true' })
        .then(async response => {
          const state = await response.json();
          if (!state || (response.ok === false && !state.status)) throw new Error('Unable to add this creation. Please try again.');
          return state;
        })
        .then(async (response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          await this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch(error => {
          this.handleErrorMessage(/^Cart/.test(error.name) ? error.message : 'Unable to add this creation. Please check your connection and try again.');
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          this.submitting = false;
        });
      if (window.JBCart) window.JBCart.enqueue(submit);
      else submit();
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    async renderContents(parsedState) {
      const requested = this.getSectionsToRender().filter(section => document.getElementById(section.id));
      let complete = true;
      requested.forEach((section => {
        const sectionRoot = document.getElementById(section.id);
        const sectionHtml = parsedState.sections?.[section.section];
        if (!sectionRoot || !sectionHtml) { complete = false; return; }
        const replacement = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (replacement === null) { complete = false; return; }
        const elementToReplace = sectionRoot.querySelector(section.selector) || sectionRoot;
        elementToReplace.innerHTML = replacement;
      }));
      if (!complete && window.JBCart) {
        // The addition is already confirmed. Recover only the rendered sections.
        const url = new URL(location.href);
        url.searchParams.set('sections', requested.map(section => section.section).join(','));
        try {
          const response = await window.JBCart.request(url, { credentials: 'same-origin' });
          if (!response.ok || !window.JBCart.render(await response.json(), requested)) throw new Error('Incomplete bag');
        } catch (_) {
          const view = document.getElementById('Cart-Drawer') || document.getElementById('Cart') || this;
          window.JBCart.error(view, 'Your creation was added to your bag. Refresh the page to see its latest contents.');
        }
      }
      dispatchCustomEvent('cart:rendered', {});
      const productDrawer = document.getElementById('Product-Drawer');
      const cartDrawer = document.getElementById('Cart-Drawer');

      if (productDrawer && productDrawer.contains(this)) {
        OverlayManager.close(productDrawer);
        if (cartDrawer) {
          OverlayManager.open(cartDrawer);
          dispatchCustomEvent('cart-drawer:open');
        }
      } else if (cartDrawer) {
        OverlayManager.open(cartDrawer);
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (!html) return null;
      const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return element ? element.innerHTML : null;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (!button || !content || this._toggleBound) return;
      this._toggleBound = true;

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          const willOpen = tl.reversed();
          button.setAttribute('aria-expanded', String(willOpen));
          willOpen ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          const isOpen = content.classList.toggle('active');
          button.setAttribute('aria-expanded', String(isOpen));
          return false;
        });
      }


    }
    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
    setupObservers() {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById('footer') || document.querySelector('footer');

      if (!('IntersectionObserver' in window) || (!form && !footer)) return;

      if (this._observer) this._observer.disconnect();

      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (footer && entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (form && entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        });
      _this.formPassed = false;
      this._observer = observer;
      if (form) observer.observe(form);
      if (footer) observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}


